export default __webpack_public_path__ + "assets/png/c654f07cd9831c223d76974d30f5ced3.png";